import React, {CSSProperties, useEffect} from "react"
import StickerDropzone from "./StickerDropzone"
import * as StickerUtil from "../../utils/StickerUtil"
import MediaContainer from "../common/MediaContainer"

interface EditImagePreviewProps {
  userImage: string
  currentOverlayUrl: string | null
  currentBackgroundUrl: string | null
}

export default function EditImagePreview({
  userImage,
  currentOverlayUrl,
  currentBackgroundUrl,
}: EditImagePreviewProps) {
  useEffect(() => {
    document.onmouseup = StickerUtil.onMouseUp
    document.ontouchcancel = StickerUtil.onMouseUp
    document.ontouchend = StickerUtil.onMouseUp

    return () => {
      document.onmouseup = null
      document.ontouchcancel = null
      document.ontouchend = null
    }
  }, [])

  const layerStyle: CSSProperties = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
  }
  return (
    <MediaContainer>
      <StickerDropzone />

      {currentBackgroundUrl != null && (
        <img
          id="selectedBackground"
          crossOrigin="anonymous"
          src={currentBackgroundUrl}
          alt="Background"
          style={{...layerStyle, zIndex: -1}}
        />
      )}

      {userImage && (
        <img
          id="userImage"
          crossOrigin="anonymous"
          src={userImage}
          alt="Preview"
          style={{...layerStyle, zIndex: 0}}
        />
      )}

      {currentOverlayUrl !== null && (
        <img
          id="overlayImage"
          crossOrigin="anonymous"
          src={currentOverlayUrl}
          alt="Overlay"
          style={{...layerStyle, zIndex: 1}}
        />
      )}
    </MediaContainer>
  )
}
